import { useEffect, useRef, useState } from 'react';
import type { LocalVideoTrack, RemoteVideoTrack } from 'livekit-client';
import { Stats } from './Stats';
import { Chart, Expand, Focus, Grid, Pip } from './icons';

export function VideoTile({
  track,
  name,
  isLocal,
  focused,
  onToggleFocus,
}: {
  track: LocalVideoTrack | RemoteVideoTrack;
  name: string;
  isLocal: boolean;
  focused: boolean;
  onToggleFocus: () => void;
}) {
  const ref = useRef<HTMLVideoElement>(null);
  const [showStats, setShowStats] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    track.attach(el);
    return () => {
      track.detach(el);
    };
  }, [track]);

  const enterFullscreen = () => {
    void ref.current?.requestFullscreen?.();
  };

  const pictureInPicture = () => {
    const el = ref.current as HTMLVideoElement & {
      requestPictureInPicture?: () => Promise<unknown>;
    };
    void el?.requestPictureInPicture?.().catch(() => {});
  };

  return (
    <div className="tile" data-focused={focused || undefined}>
      <video
        ref={ref}
        autoPlay
        playsInline
        // A propria tela volta em eco; mutar evita microfonia com o Discord.
        muted={isLocal}
        onDoubleClick={enterFullscreen}
      />

      <span className="tile-name">{isLocal ? `${name} (voce)` : name}</span>

      <div className="tile-actions">
        <button
          className="icon-btn"
          data-on={showStats}
          title="Estatisticas"
          aria-label="Estatisticas"
          aria-pressed={showStats}
          onClick={() => setShowStats((v) => !v)}
        >
          <Chart />
        </button>
        <button
          className="icon-btn"
          title="Picture-in-picture"
          aria-label="Picture-in-picture"
          onClick={pictureInPicture}
        >
          <Pip />
        </button>
        <button
          className="icon-btn"
          title={focused ? 'Voltar para a grade' : 'Destacar esta tela'}
          aria-label={focused ? 'Voltar para a grade' : 'Destacar esta tela'}
          onClick={onToggleFocus}
        >
          {focused ? <Grid /> : <Focus />}
        </button>
        <button
          className="icon-btn"
          title="Tela cheia"
          aria-label="Tela cheia"
          onClick={enterFullscreen}
        >
          <Expand />
        </button>
      </div>

      {showStats && <Stats track={track} />}
    </div>
  );
}
